/**
 * TMR Translation Configuration.
 *
 * Configures the Angular translate module.
 *
 * @type {ngConfig}
 * @see https://angular-translate.github.io/docs/#/guide
 */
function tmrTranslationConfig(
  $translateProvider,
  tmhDynamicLocaleProvider,
  TmrLocalStorageProvider,
  tmrLanguages
) {
  'ngInject'
  // Setup translations.
  $translateProvider
    .storagePrefix(TmrLocalStorageProvider.prefix)
    .useLocalStorage()
    .useSanitizeValueStrategy('escapeParameters')
    // Allows use of messageformat.js for pluralization and gender.
    // Use with translate-interpolation="messageformat" attribute.
    // @see https://angular-translate.github.io/docs/#/guide/14_pluralization
    .addInterpolation('$translateMessageFormatInterpolation')

  // Register enabled languages.
  let enabled = Object.keys(tmrLanguages.languages)
  let aliases = {}
  for (const langCode in tmrLanguages.languages) {
    if (tmrLanguages.languages[langCode].alias)
      aliases[tmrLanguages.languages[langCode].alias] = langCode
  }
  $translateProvider.registerAvailableLanguageKeys(enabled, aliases)

  // Configurable default language. If tmrLanguages.default is empty, let the
  // translation module decide the best language for this user.
  if (tmrLanguages.default) {
    $translateProvider.fallbackLanguage(tmrLanguages.default)
    $translateProvider.preferredLanguage(tmrLanguages.default)
  } else {
    $translateProvider.determinePreferredLanguage()
    $translateProvider.fallbackLanguage($translateProvider.preferredLanguage())
  }

  // Add asynchronous translation sources (imported at top of file).
  $translateProvider.useStaticFilesLoader({
    prefix: 'translations/',
    suffix: '.json',
  })

  // Default dynamic locale.
  tmhDynamicLocaleProvider.defaultLocale($translateProvider.preferredLanguage())
}

export { tmrTranslationConfig as config }
